export { default } from "bullitttime-embermodelsevent/adapters/intermediate-timing-record";
